import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AbstractAuditReviewService } from '../abstraction/abstract.audit-review.service';
import { ITableServerResponseFilter } from '../../../common/interfaces/table/table-server-filter-response.interface';
import { ITableServerFilter } from '../../../common/interfaces/table/table-server-filter.inteface';

@Injectable({
  providedIn: 'root',
})
export class AuditReviewService extends AbstractAuditReviewService {
  controller = `/manager/configurationauditview`;
  urlGetAuditList = `${environment.apiUrl}${this.controller}/grid`;
  urlGetGridExportCSV = `${environment.apiUrl}${this.controller}/gridExportCSV`;
  urlGetGridExportExcel = `${environment.apiUrl}${this.controller}/gridExportExcel`;

  constructor(private http: HttpClient) {
    super();
  }

  tableFilter(filter: ITableServerFilter): Promise<ITableServerResponseFilter | undefined> {
    return this.http
      .post<ITableServerResponseFilter>(`${this.urlGetAuditList}`, filter)
      .toPromise();
  }
  tableExportCSV(filter: ITableServerFilter): Promise<Blob | undefined> {
    return this.http
      .post(`${this.urlGetGridExportCSV}`, filter, {
        responseType: 'blob',
      })
      .toPromise();
  }
  tableExportExcel(filter: ITableServerFilter): Promise<any> {
    return this.http.post(`${this.urlGetGridExportExcel}`, filter).toPromise();
  }
}
